"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotSessionsFilterController = function () {
  function BotSessionsFilterController($scope, FilterService, EventsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BotSessionsFilterController);
    this.filterService = FilterService;
    this.eventsService = EventsService;

    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true);
  }

  (0, _createClass3.default)(BotSessionsFilterController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.setFilterOptions();

      this.eventsService.listen(_constants2.default.events.GLOBAL_FILTER_APPLIED, function (e, globalFilter) {
        console.log("Bot Sessions global filter applied::", globalFilter);

        _this.setFilterOptions(globalFilter.type);
      });
    }
  }, {
    key: "setFilterOptions",
    value: function setFilterOptions(activeGlobalFilter) {
      this.filterOptions = this.filterService.getbotSessionsFilterOptions(activeGlobalFilter);
      return this.filterOptions;
    }
  }, {
    key: "onFilterChagne",
    value: function onFilterChagne(newval, oldval) {
      this.filterService.generateFilterExpression(this.filterOptions);
      this.applyFilters();
    }
  }]);
  return BotSessionsFilterController;
}();

exports.default = BotSessionsFilterController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/bot-sessions-filter/bot-sessions-filter.controller.js
 **/